<template>
	<div class="global-slider-container">
		<div :class='`slider-${componentParams.template}`'>
			<template v-if='componentParams.template == "default"'>
					<slider-default :items='items' @updated='renderOwl'></slider-default>
			</template>
			<template v-else-if='componentParams.template == "mainSlider"'>
					<slider-mainSlider :items='items' @updated='renderOwl'></slider-mainSlider>
			</template>
			<template v-else-if='componentParams.template == "categorySlider"'>
					<slider-category :items='items' @updated='renderOwl'></slider-category>
			</template>
			<template v-else-if='componentParams.template == "popSlider"'>
					<slider-popProduct :items='items' @updated='renderOwl'></slider-popProduct>
			</template>
			<template v-else-if='componentParams.template == "swimSlider"'>
					<slider-swim :items='items' @updated='renderOwl'></slider-swim>
			</template>
			<template v-else-if='componentParams.template == "aboutSlider"'>
					<slider-about :items='items' @updated='renderOwl'></slider-about>
			</template>


			<template v-else>
				Unknown slider template: <b>{{ componentParams.template }}</b>
			</template>
		</div>
	</div>
</template>

<script>
require('__scss/owl.carousel.scss');
require('owl.carousel');

module.exports = {
	props: {
		dataParams: {
			type: String,
			required: true
		},
		dataStaticParams: {
			type: String,
			required: false
		}
	},

	components: {
		'slider-default': require('./sliders/default.vue'),
		'slider-mainSlider': require('./sliders/mainSlider.vue'),
		'slider-category': require('./sliders/sliderCategory.vue'),
		'slider-popProduct': require('./sliders/popProduct.vue'),
		'slider-swim': require('./sliders/swimSlider.vue'),
		'slider-about': require('./sliders/aboutSlider.vue')
	},

	data () {
		return {
			api_response: {},
			items: []
		}
	},

	computed: {
		componentParams() {
			let str = this.dataParams.replace(/'/g, '"');
			return JSON.parse(str);
		},
		staticParams() {
			let str2 = this.dataStaticParams.replace(/'/g, '"');
			return JSON.parse(str2);
		}
		// items() {
		// 	return this.api_response ? this.api_response.items : [];
		// }
	},

	watch: {
		api_response() {
			this.items = this.api_response.items;
		}
	},

	methods: {
		renderOwl(payload) {
			$(this.$el).find('.owl-carousel').trigger('destroy.owl.carousel');
			$(this.$el).find('.owl-carousel .owl-item').remove();
			$(this.$el).find('.owl-carousel').owlCarousel(payload.owlSettings);
		}
	},

	mounted() {
		if(this.dataStaticParams) {
			this.items = this.staticParams;
			this.locked = false;
		}else{
			let method = this.componentParams.method;
			let url = this.componentParams.url;
			let custom_request = this.componentParams.request;

			let options = {
				responseType: 'json'
			}

			if(method.toLowerCase() == 'post') {
				options.emulateJSON = true;
				this.$http[method](url, custom_request, options).then(success).catch(error);
			}
			else if(method.toLowerCase() == 'get') {
				options.params = custom_request;
				this.$http[method](url, options).then(success).catch(error);
			}

			function success(response) {
				// console.log(response)
				this.api_response = response.body.api_response;
			}

			function error(err) {
				console.log(err);
			}
		}
	}

	// mounted() {
	// 	const success = response => {
	// 		// console.log(response.body);
	// 		this.api_response = response.body ? response.body.api_response : {};
	// 	}
	//
	// 	const error = error => {
	// 		console.log(error);
	// 	}
	//
	// 	let method = this.componentParams.method;
	// 	let url = this.componentParams.url;
	// 	let custom_request = this.componentParams.request;
	//
	// 	let options = {
	// 		responseType: 'json'
	// 	}
	//
	// 	if(method.toLowerCase() == 'post') {
	// 		options.body = custom_request
	// 	}
	// 	else if(method.toLowerCase() == 'get') {
	// 		options.params = custom_request
	// 	}
	//
	// 	this.$http[method](url, options)
	// 		.then(response => {
	// 			// console.log(response);
	// 			this.api_response = response.body ? response.body.api_response : {};
	// 		})
	// 		.catch(err => {
	// 			console.log(err);
	// 		});
	// }
}
</script>

<style lang="scss">
@import "scss/wanted";

</style>



// WEBPACK FOOTER //
// Slider.vue?241b16e0